import { CHAR_CODES, Icon54 } from "@/components/Icon54/Icon54";
import { buttonVariants } from "@/design-system/Button";
import { twResolve } from "@/helpers/tw-resolve";
import { useTranslation } from "@/translations";

export interface IconPickerProps {
  onChange: (charCode: number) => void;
  selectedCharCode: number | null;
}

export function IconPicker({ onChange, selectedCharCode }: IconPickerProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <section className="grid w-full grid-cols-control-fill grid-rows-control-fill justify-center gap-space-sm">
      {CHAR_CODES.map((charCode, index) => {
        const isSelected = selectedCharCode === charCode;

        return (
          <button
            type="button"
            key={charCode}
            className={twResolve(
              buttonVariants({ variant: "outline", size: "md", inset: "compact", content: "icon" }),
              "size-control-md",
              isSelected ? "border-border-brand bg-background-brand-light" : "border-border-secondary",
            )}
            aria-label={t("component.group-icon-picker-input.option-label", { index: index + 1 })}
            aria-pressed={isSelected}
            data-testid="icon-char-action-select"
            onClick={() => {
              onChange(charCode);
            }}
          >
            <Icon54 appearance="picker" charCode={charCode} disableUserSelect />
          </button>
        );
      })}
    </section>
  );
}
